export default function () {
    const $body = $("body");
    const headerContent = ".header-content";
    const stickyHead = "sticky-head";
    const $pageHeader = $(".page-header");
    var timeoutId;

    $(document).ready(function() {
        if (!$pageHeader.length) {
            return;
        }

        var currentScroll = 0;
        $(window).scroll(function() {
            var currentUp = $(window).scrollTop();
            var isRemoveSticky = $(headerContent).hasClass("js-remove-sticky");

            if (currentUp > currentScroll || isRemoveSticky) {
                $(headerContent).removeClass(stickyHead);
                $body.removeClass("isSticky");

                if (timeoutId) {
                    timeoutId = null;
                } else if (isRemoveSticky) {
                    timeoutId = setTimeout(function() {
                        $(headerContent).removeClass("js-remove-sticky");
                    }, 500);
                }
            } else {
                $(headerContent).addClass(stickyHead);
                $body.addClass("isSticky");
            }
            if ($(window).scrollTop() <= $pageHeader.height()) {
                $(headerContent).removeClass(stickyHead);
                $body.removeClass("isSticky");
            }
            currentScroll = currentUp;
        });
    });
}
